import { generatePath, useLoaderData, useNavigate, useParams } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { omaElisaForEmployeeMsg, orderRequestsMsg, t } from '../../../../../common/i18n/index.js';
import { DeliveryOrderDetails } from '../../../../../components/DeliveryOrderDetails/DeliveryOrderDetails.js';
import type { DeliveryId, OrderId } from '../../../../../common/constants/pathInterfaces.js';
import type { DeliveryOrderLoaderData } from '../../../../../common/loaders';

export const EoeFinishedReviewItemPath = () => {
  const navigate = useNavigate();
  const { orderId, deliveryId } = useParams<OrderId & DeliveryId>();
  const { customerOrder } = useLoaderData() as DeliveryOrderLoaderData;
  const deliveryOrder = customerOrder.deliveryOrders.find(e => e.deliveryOrderDisplayId === deliveryId);

  useTitle([
    t.H6JV(omaElisaForEmployeeMsg),
    t.Y29L(orderRequestsMsg),
    customerOrder?.customerOrderDisplayId ?? '',
    deliveryOrder?.deliveryOrderName ?? '',
  ]);

  if (!(customerOrder && deliveryOrder)) {
    return null;
  }

  return (
    <DeliveryOrderDetails
      customerOrder={customerOrder}
      deliveryOrder={deliveryOrder}
      onClickCustomerOrder={() => {
        navigate(generatePath(paths.EMPLOYEE_FINISHED_REVIEW_ORDER, { orderId }));
      }}
      breadCrumbPaths={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.Y29L(orderRequestsMsg), path: paths.EMPLOYEE_FINISHED_REVIEW_ORDERS },
        {
          name: customerOrder.customerOrderDisplayId,
          path: generatePath(paths.EMPLOYEE_FINISHED_REVIEW_ORDER, { orderId }),
        },
        { name: deliveryOrder.deliveryOrderName },
      ]}
      isApprover={true}
      showOrderConfirmationDownload={false}
    />
  );
};
